import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { trackFAQClick } from '@/helpers/dataLayer';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  PageMargins,
} from './Faq.style';

const Faq = ({ list, headline }) => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleQuestion = id => {
    const isActive = id === activeQuestion;
    setActiveQuestion(isActive ? null : id);
    if (!isActive) {
      trackFAQClick();
    }
  };

  const hasEntries = list && list.length > 0;

  const renderEntry = (id, question, answer) => {
    const expanded = id === activeQuestion;
    return (
      <Accordion
        data-test-subject={`question-${id}`}
        key={id}
        expanded={expanded}
        onClick={() => toggleQuestion(id)}
        elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color="primary" />}
          aria-controls="panel1-content"
          id="panel1-header">
          <Typography
            variant="body1Redesign"
            component="p"
            color={expanded ? 'text.primary' : 'text.secondary'}
            {...(expanded && {
              fontWeight: theme => theme.typography.fontWeightMedium,
            })}>
            {question}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{answer}</AccordionDetails>
      </Accordion>
    );
  };

  return (
    <PageMargins>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Typography
            data-test-subject="headline"
            color="primary.dark"
            variant="h4Redesign"
            component="h2">
            {headline}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          {hasEntries &&
            list.map(({ id, question, answer }) =>
              renderEntry(id, question, answer)
            )}
        </Grid>
      </Grid>
    </PageMargins>
  );
};

export default Faq;

Faq.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.node.isRequired,
      answer: PropTypes.node.isRequired,
    })
  ).isRequired,
  headline: PropTypes.string.isRequired,
};
